import { usePath } from '@elsa/ui';
import { useEffect } from 'react';
import { AppShell } from './app/AppShell.tsx';
import { releaseBoot } from './app/loading.tsx';
import { AuthPage, NewPasswordPage } from './pages/Auth.tsx';
import { InvitePage } from './pages/Invite.tsx';
import { LandingPage } from './pages/Landing.tsx';
import { CookiesPage, PrivacyPage, TermsPage } from './pages/Legal.tsx';
import { NotFound, PublicLayout } from './pages/PublicLayout.tsx';

// Rutele publice (prezentarea, paginile legale, autentificarea) si aplicatia de sub /app.
export function App() {
  const path = usePath();
  // Ecranul static de pornire (index.html): in aplicatie il preia PageLoader, in rest se stinge.
  useEffect(releaseBoot, []);
  if (path === '/app' || path.startsWith('/app/')) return <AppShell path={path} />;
  const page = (() => {
    switch (path) {
      case '/':
        return <LandingPage />;
      case '/termeni':
        return <TermsPage />;
      case '/confidentialitate':
        return <PrivacyPage />;
      case '/cookie-uri':
        return <CookiesPage />;
      case '/autentificare':
        return <AuthPage />;
      case '/parola-noua':
        return <NewPasswordPage />;
      case '/invitatie':
        return <InvitePage />;
      default:
        return <NotFound />;
    }
  })();
  return <PublicLayout>{page}</PublicLayout>;
}
